import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { forwardRef } from 'react';

const LIST_BOX_CLASSES = {
    hidden: "hidden",
};
const ListBox = forwardRef(function ListBox(_a, ref) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsx(Wrapper, Object.assign({ ref: ref }, props, { children: children })));
});
const Wrapper = styled("ul")(({ theme }) => ({
    position: "absolute",
    zIndex: 1,
    transition: "opacity .1s ease",
    marginTop: 0,
    // https://supercharged.atlassian.net/browse/MP-1611
    boxShadow: "0px 4px 8px rgba(112, 144, 176, 0.1),  inset 0px 0px 0px 1px #d2d3d5",
    borderRadius: 4,
    boxSizing: "border-box",
    width: "100%",
    height: "auto",
    padding: 0,
    background: theme.palette.ui12,
    listStyle: "none",
    outline: "none",
    [`&.${LIST_BOX_CLASSES.hidden}`]: {
        opacity: 0,
        transition: "opacity .1s .2s ease, visibility .1s .2s step-end",
        visibility: "hidden",
    },
    "& > *:first-of-type": {
        marginTop: theme.spacing(1),
    },
    "& > *:last-of-type": {
        marginBottom: theme.spacing(1),
    },
}));

export { LIST_BOX_CLASSES, ListBox };
//# sourceMappingURL=ListBox.js.map
